<template>
  <Icon>
    <template #component>
      <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        <path
          d="M885.05,1015.78H143A130.76,130.76,0,0,1,12.34,885.17V143.07A130.76,130.76,0,0,1,143,12.46h742.1a130.76,130.76,0,0,1,130.61,130.61v742.1A130.76,130.76,0,0,1,885.05,1015.78ZM143,76.46a66.68,66.68,0,0,0-66.61,66.61v742.1A66.68,66.68,0,0,0,143,951.78h742.1a66.68,66.68,0,0,0,66.61-66.61V143.07a66.68,66.68,0,0,0-66.61-66.61Z"
          transform="translate(-12.34 -12.46)"
          fill="currentColor"
        />
        <path
          d="M384,636.28H322.81L298.5,573H187.21l-23,63.24H104.6L213,357.86h59.44ZM280.46,526.13,242.09,422.81l-37.6,103.32Z"
          transform="translate(-12.34 -12.46)"
          fill="currentColor"
        />
        <path
          d="M414,357.86H525.26q33,0,49.28,2.76a72.35,72.35,0,0,1,29.05,11.49A71.56,71.56,0,0,1,625,395.37a63,63,0,0,1,8.55,32.57,66,66,0,0,1-39.12,60.4q25.44,7.41,39.12,25.26t13.67,42a82.67,82.67,0,0,1-8.83,36.93,74.22,74.22,0,0,1-24.12,28.68q-15.29,10.74-37.7,13.2-14.06,1.53-67.79,1.9H414Zm56.21,46.34v64.38H507q32.85,0,40.83-.94,14.43-1.71,22.69-10t8.26-21.74q0-12.92-7.12-21t-21.18-9.78q-8.35-.94-48-.95Zm0,110.73v74.44h52q30.38,0,38.55-1.71a34.79,34.79,0,0,0,20.41-11.11q7.89-8.84,7.89-23.64,0-12.54-6.08-21.27t-17.57-12.73q-11.49-4-49.85-4Z"
          transform="translate(-12.34 -12.46)"
          fill="currentColor"
        />
        <path
          d="M872.8,533.91l54.51,17.29q-12.54,45.57-41.69,67.7t-74,22.13q-55.46,0-91.16-37.89t-35.7-103.59q0-69.53,35.89-108t94.39-38.45q51.09,0,83,30.19,19,17.85,28.49,51.28L870.9,447.88Q866,426.24,850.3,413.7t-38.08-12.54q-31,0-50.23,22.23t-19.28,72q0,52.8,19,75.21T811.08,593q22.41,0,38.55-14.24T872.8,533.91Z"
          transform="translate(-12.34 -12.46)"
          fill="currentColor"
        />
      </svg>
    </template>
  </Icon>
</template>
<script lang="ts">
interface size {
  height: number;
  width: number;
}
import { defineComponent } from "vue";
import Icon from "@ant-design/icons-vue";
export default defineComponent({
  components: {
    Icon,
  },
});
</script>
<style scoped>
.custom-icons-list :deep(.anticon) {
  margin-right: 6px;
}
</style>
